import { withSelect, withDispatch } from '@wordpress/data';
const applyWithSelect = withSelect((select, props) => {
    return {
        metaValue: select('core/editor').getEditedPostAttribute('meta')[props.metaKey],
    };
});
const applyWithDispatch = withDispatch((dispatch, props) => {
    return {
        setMetaValue(value) {
            dispatch('core/editor').editPost({ meta: { [props.metaKey]: value } });
        },
    };
});
function apply(el) {
    return applyWithSelect(applyWithDispatch(el));
}
export default apply;
